import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFindingCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={54}
    height={54}
    fill="none"
    {...props}
  >
    <circle cx={27} cy={27} r={27} fill="#776BFF" opacity={0.1} />
    <path
      fill="url(#FindingCircle_svg__a)"
      d="M29.56 16.435c-1.137-1.97-3.983-1.97-5.12 0l-7.87 13.63c-1.138 1.97.285 4.435 2.561 4.435H34.87c2.276 0 3.699-2.464 2.56-4.435z"
    />
    <path
      fill="#fff"
      d="M27.055 19.668c.604.01 1.086.506 1.078 1.11v5.036a1.097 1.097 0 0 1-1.095 1.11 1.1 1.1 0 0 1-1.096-1.11v-5.036a1.095 1.095 0 0 1 1.113-1.11m-.017 8.774a1.096 1.096 0 1 1-.001 2.191 1.096 1.096 0 0 1 0-2.191"
      opacity={0.75}
    />
    <defs>
      <linearGradient
        id="FindingCircle_svg__a"
        x1={42}
        x2={12}
        y1={21}
        y2={37.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D4D3FF" />
        <stop offset={1} stopColor="#776BFF" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgFindingCircle;
